import { useEffect, useMemo } from "react";
import { Collapse } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useEventContext } from "../../context/EventContext/EventContext";
import { EventItemKeys, getEventItems } from "./constants";

const AddEvent = () => {
	const { addEvent, clearEventFormData, eventForm, setEventForm, operationStatus } = useEventContext();

	useEffect(() => {
		clearEventFormData();
		setEventForm(prev => ({
			...prev,
			isAppliable: false,
			eventPreview: {
				...prev.eventPreview,
				isFeatured: false,
			},
			eventDetail: {
				...prev.eventDetail,
				hasCustomButton: false,
			},
		}));

		return () => {
			clearEventFormData();
		};
	}, []);

	const items = useMemo(
		() => getEventItems(eventForm.eventType, eventForm.eventDetail.hasCustomButton),
		[eventForm.eventType, eventForm.eventDetail.hasCustomButton]
	);

	return (
		<>
			<BackComponent text="Proje Listesine Dön" />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>Proje Ekleme</FormHeaderComponent>
					<Collapse
						items={items}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={EventItemKeys}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={addEvent} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
							Proje Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddEvent;
